
/**
 * 可视区域分析
 */

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { getSurfaceHeight } from "./utils/index"
import ViewShed from "./viewShed/ViewShed"
class ViewShedAnalysis extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.sheds = [];
        this.style = {
            clampToGround: false
        }
    }

    rightClick(evt) {
        super.rightClick(evt);
       
        var view = new ViewShed(viewer, {
            viewPosition: this.positions[0],
            viewPositionEnd: this.positions[1],
        });
        this.sheds.push(view);
    }

    leftClick(evt) {
        if (!this.plot) {
            super.leftClick(evt);

            // var cartesian = this.positions[0];
            // var label1 = ConstantDraw.Style_Label;
            // label1.text = "起点";
            // this.startPoint = this.createPoint(cartesian);
            // this.startPoint.label = label1;

            // var cartesian = this.positions[0];
            // var label2 = ConstantDraw.Style_Label;
            // label2.text = "终点";
            // label2.heightReference = Cesium.HeightReference.NONE;
            // this.endPoint = this.createPoint(cartesian);
            // this.endPoint.label = label2;

            // this.entities.push(this.startPoint);
            // this.entities.push(this.endPoint);
        }
    }

    clear(){
        super.clear();
        this.sheds.forEach(v=>{
            v.clear();
        });
    }

    initEditor() {
    }

    reset() {
        super.reset();
        this.sum = 0;
        this.entitiesLabel = [];
        this.startPoint = null;
        this.endPoint = null;
    }

    initKeyPositions() {
        var arr = [];
        for (let i = 0; i < this.entitiesLabel.length; i++) {
            var pos = this.entitiesLabel[i].position.getValue();
            arr.push(pos);
        }
        this.positions = arr; //
        this.plot.attrPlot = {
            edit_positions: this.positions.slice(),
            entitiesLabel: this.entitiesLabel
        }; //标绘标识
    }

}

export default ViewShedAnalysis